import { Omschrijvingen, ReikwijdtePicker } from "../shared";

export function NietSpoorwebStep() {
    return (
        <div className="grid gap-4 p-6 pb-8">
            <Omschrijvingen />
            <ReikwijdtePicker />
        </div>
    );
}
